import axios from "axios";
import { HttpClient, RequestParams } from "../../utils/api/http-client";
import IBaseListingResponse from "../../utils/api/base-listing-response";

import { IHomePageSectionsArrangementQuery } from "../../models/arrange_sections_page_home/query";
import { IHomePageSectionsArrangementList } from "../../models/arrange_sections_page_home/response";
import { IUpdateHomePageSectionsArrangement } from "../../models/arrange_sections_page_home/request";

class HomeSectionsArrangementService<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  getAllHomePageSectionsArrangementLists = (query: IHomePageSectionsArrangementQuery, params?: RequestParams) =>
    this.http.request<IBaseListingResponse<IHomePageSectionsArrangementList>>({
      path: `/arrange-sections-page-home`,
      method: "GET",
      query,
      ...params,
    });

  updateHomePageSectionsArrangementList = (id: number, data: IUpdateHomePageSectionsArrangement, params?: RequestParams) =>
    this.http.request<IHomePageSectionsArrangementList>({
      path: `/arrange-sections-page-home/${id}`,
      method: "PUT",
      body: data,
      ...params,
    });

}

export default HomeSectionsArrangementService;
